import apiClient from "../../app/apiClient";
import { getSession } from "../../app/auth";

function requireSuperadmin() {
  if (getSession()?.role !== "SUPERADMIN") throw new Error("Only super administrators can manage admin accounts.");
}

export async function listAdmins() {
  requireSuperadmin();
  const { data } = await apiClient.get("/superadmin/admin");
  const records = Array.isArray(data) ? data : data?.admins ?? data?.data;
  if (!Array.isArray(records)) throw new Error("The server returned an invalid admin list.");
  return records.map((admin) => {
    const enabled = admin.isEnable ?? admin.enabled ?? admin.isEnabled;
    if (admin.id == null || ![true, false, "true", "false", 1, 0].includes(enabled)) {
      throw new Error("The server returned incomplete admin account information.");
    }
    return { id: admin.id, name: admin.fullname || admin.fullName || admin.userName || "Unnamed admin", email: admin.email || "", phone: admin.phoneNumber || "", role: String(admin.role || "").trim().toUpperCase().replace(/^ROLE_/, ""), enabled: [true, "true", 1].includes(enabled) };
  });
}

export async function createAdmin(profile) {
  requireSuperadmin();
  const { fullName, email, phoneNumber, role } = profile;
  if (!["ADMIN", "SUPERADMIN"].includes(role)) throw new Error("Select ADMIN or SUPERADMIN.");
  return apiClient.post("/superadmin/admin", { fullName, email, phoneNumber, role });
}

export async function setAdminEnabled(id, isEnabled) {
  requireSuperadmin();
  return apiClient.patch(`/superadmin/admin/${encodeURIComponent(id)}`, { isEnabled });
}

export async function updateAdminProfile(id, profile) {
  requireSuperadmin();
  const { fullname, email, phoneNumber, role, isEnable } = profile;
  if (!["ADMIN", "SUPERADMIN"].includes(role)) throw new Error("Select ADMIN or SUPERADMIN.");
  if (typeof isEnable !== "boolean") throw new Error("Select an account status.");
  return apiClient.patch(`/superadmin/admin/${encodeURIComponent(id)}/profile`, { fullname, email, phoneNumber, role, isEnable });
}
